<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container customer_high_seas_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"> </ReturnNavBar>
                    <div class="returnNavBarRight">
                        <van-popover
                            v-model="showOperatorPopover"
                            placement="bottom-end"
                            trigger="click"
                            ref="top_operator_popover"
                            class="top_operator_popover"
                        >
                            <div class="top_operator_list">
                                <li v-for="item in operatorList" :key="item.type" @click="handleClickOperate(item)">
                                    <i :class="['iconfont', item.icon]"></i><span>{{ item.title }}</span>
                                </li>
                            </div>
                            <template #reference>
                                <i class="iconfont icon-a-tianjiamiaobian"></i>
                            </template>
                        </van-popover>
                    </div>
                </div>
                <div class="top_search">
                    <van-search
                        v-model="searchForm.keyword"
                        placeholder="请输入查询内容"
                        @search="onSearch"
                        @clear="onSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <div class="no-empty-list" v-if="!tableData.length">
                        <img
                            src="https://download.hecoos.com/enlightv/2024-48/4e42cbd3ef1bb6ec5d6f0de2b536b48d.png"
                            alt=""
                        />
                        <p>暂无客户</p>
                        <van-button type="info" class="add_btn" @click="handleClickAdd"
                            ><van-icon name="plus"></van-icon>新建客户</van-button
                        >
                    </div>
                    <ul class="list_wrap" v-infinite-scroll="onLoadList">
                        <li v-for="item in tableData" :key="item.id" class="list_item">
                            <div class="list_item_info" @click="handleClickToDetail(item)">
                                <p>
                                    <span class="ellipsis">{{ item.name && item.name.value }}</span
                                    ><span v-if="item.claim_status === 0" class="item_status1">申领中</span>
                                </p>
                                <p>由公海创建</p>
                            </div>
                            <div class="list_item_checkbox" v-if="isCheck">
                                <van-checkbox
                                    v-model="item.checked"
                                    shape="square"
                                    @change="handleClickChangeSelect(item)"
                                ></van-checkbox>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="batch_select_icon" v-if="isCheck" @click="handleClickShowCompany">
                    <i class="iconfont icon-renyuan"></i
                    ><span v-if="selectedList.length">{{ selectedList.length }}</span>
                </div>
                <!-- 选择客户列表 -->
                <SelectCompanyList
                    :selectCompanyListVisible.sync="selectCompanyListVisible"
                    :selectCompanyData.sync="selectedList"
                    @changeItemSelete="changeItemSelete"
                />
                <!-- 批量操作底部操作栏 -->
                <BatchOperateBar
                    :operateBarList="operateBarList"
                    @handleClickOperateType="handleClickOperateType"
                    v-if="isCheck"
                />
                <!-- 公海选择 -->
                <van-overlay
                    :custom-style="{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 99999 }"
                    v-if="highSeasSelectVisible"
                    :show="highSeasSelectVisible"
                >
                    <div class="radio_option_wrap">
                        <ul class="radio_option_list">
                            <li
                                v-for="item in highSeasActions"
                                class="radio_option_item"
                                @click="handleHighSeasSelect(item)"
                                v-text="item.name"
                            ></li>
                        </ul>
                        <div class="cancel_btn" @click="highSeasSelectVisible = false">取消</div>
                    </div>
                </van-overlay>

                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                <ListAdvancedFiltering
                    v-if="searchPopupShow"
                    ref="listAdvancedFiltering"
                    :field_form="'customers'"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
                <CustomerApply
                    v-if="customerApplyPopupShow"
                    :customerApplyPopupShow.sync="customerApplyPopupShow"
                    :sea_id="searchForm.sea_id"
                    :companyList="selectedList"
                    @applySuccess="onPullRefreshList"
                />
                <CustomerAllocation
                    v-if="customerAllocationPopupShow"
                    :customerAllocationPopupShow.sync="customerAllocationPopupShow"
                    :sea_id="searchForm.sea_id"
                    :companyList="selectedList"
                    @allocationSuccess="onPullRefreshList"
                />
                <CustomerTransfer
                    v-if="customerTransferPopupShow"
                    :customerTransferPopupShow.sync="customerTransferPopupShow"
                    :sea_id="searchForm.sea_id"
                    :companyList="selectedList"
                    @transferSuccess="onPullRefreshList"
                />
            </div>
        </template>
    </PullContainer>
</template>

<script>
import { mapState } from "vuex";
import { pagination } from "@/mixins";
import { GetHighSeasManagementList, GetCustomerPublicList, CustomerPublicDel,checkClaimNum } from "@/api";
import { Dialog } from "vant";
import { EventBus } from '@/utils/eventBus';
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import BatchOperateBar from "./component/batch_operate_bar.vue";
import SelectCompanyList from "./component/select_company_list.vue";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import CustomerApply from "./customer_apply.vue";
import CustomerAllocation from "./customer_allocation.vue";
import CustomerTransfer from "./customer_transfer.vue"

export default {
    name: "CustomerHighSeas",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        BatchOperateBar,
        SelectCompanyList,
        ListAdvancedFiltering,
        CustomerApply,
        CustomerAllocation,
        CustomerTransfer
    },
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "MCustomerSeas",
                    title: "首页",
                },
                {
                    icon: "icon-a-fenzu450",
                    activeIcon: "icon-gonghai-xuanzhong",
                    routerName: "CustomerHighSeas",
                    title: "公海客户",
                },
                {
                    icon: "icon-sihai",
                    activeIcon: "icon-sihai-xuanzhong",
                    routerName: "CustomerPrivateSeas",
                    title: "私海客户",
                },
            ],
            tabBarActive: 1,
            searchForm: {
                keyword: "",
                sea_id: "",
            },
            tableData: [],
            highSeasList: [],
            showOperatorPopover: false,
            operatorList: [
                { icon: "icon-a-shenling1", title: "新增客户", type: "add" },
                { icon: "icon-fenpei", title: "公海切换", type: "switch" },
                { icon: "icon-fenpei", title: "批量操作", type: "batch" },
            ],
            isCheck: false, // 是否批量选择
            selectedList: [], // 复选框选中数据
            selectCompanyListVisible: false, // 选择的公司列表
            operateBarList: [
                { icon: "icon-daochu", title: "申领", type: "apply" },
                { icon: "icon-a-shenling1", title: "分配", type: "allocation" },
                { icon: "icon-qiehuan", title: "转移", type: "transfer" },
                { icon: "icon-shanchu1", title: "删除", type: "delete" },
            ],
            highSeasSelectVisible: false, // 公海切换
            highSeasActions: [],
            systemFilterFields: [], // 高级筛选字段
            custom_filter: {}, // 高级筛选确认条件
            // 申领
            customerApplyPopupShow: false,
            // 分配
            customerAllocationPopupShow: false,
            // 转移
            customerTransferPopupShow: false
        };
    },
    mixins: [pagination],
    created() {
        EventBus.$on('customerAddUpdated', !this.searchForm.sea_id ? this.getHighSeasManagementList: this.onPullRefreshList);
        EventBus.$on('customerEditUpdated', !this.searchForm.sea_id ? this.getHighSeasManagementList: this.onPullRefreshList);
        if (!this.searchForm.sea_id) {
            this.getHighSeasManagementList();
        } else {
            this.onPullRefreshList();
        }
    },
    computed: {
        ...mapState(["searchPopupShow"]),
    },
    methods: {
        handleClickReturnRouter() {
            if(this.isCheck) {
                this.isCheck = false
            } else {
                if (this.$router.history.length <= 1) {
                    // 没有上一页，跳转到固定页面
                    this.$router.push({ name: 'mobileAllFunctions' });
                } else {
                    // 有上一页，后退
                    this.$router.go(-1);
                }
            }
        },
        pullDownLoadingSuccess(flag) {
            if (flag) {
                setTimeout(() => {
                    this.pullDownLoading = true;
                    this.onPullRefreshList();
                }, 3000);
            }
        },
        // 获取自定义字段列表
        getFieldList() {
            getFormFields({
                field_form: "customers",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data.reduce((acc, item) => {
                        acc.push(item);
                        if (item._child) {
                            acc.push(...item._child);
                        }
                        return acc;
                    }, []);
                }
            });
        },
        // 搜索
        onSearch() {
            this.onPullRefreshList();
        },
        // 右上角操作
        handleClickOperate(item) {
            if (item.type === "batch") {
                // 批量操作
                this.isCheck = true;
            } else if (item.type === "switch") {
                // 公海切换
                this.isCheck = false;
                this.highSeasSelectVisible = true;
            } else if (item.type === "add") {
                this.$router.push({
                    name: "MCustomerAdd",
                    query: {
                        addType: "public",
                        sea_id: this.searchForm.sea_id,
                    },
                });
            }
            this.showOperatorPopover = false;
        },
        handleClickAdd() {
            this.$router.push({
                name: "MCustomerAdd",
                query: {
                    addType: "public",
                },
            });
        },
        handleClickChangeSelect(item) {
            if (item.checked) {
                this.selectedList.push(item);
            } else {
                const index = this.selectedList.findIndex((list) => list.id == item.id);
                this.selectedList.splice(index, 1);
            }
        },
        // 选中的公司列表弹框
        handleClickShowCompany() {
            this.selectCompanyListVisible = true;
        },
        // 复选框选中状态
        changeItemSelete(data) {
            if (data.type == "item") {
                // 取消单个选中
                const item = data.data;
                const list = this.tableData.find((list) => list.id === item.id);
                if (list) {
                    this.$set(list, "checked", false);
                }
            } else {
                // 取消全部的选择
                this.tableData.forEach((item) => {
                    this.$set(item, "checked", false);
                });
            }
        },
        // 批量操作确认类型
        handleClickOperateType(type) {
            if (!this.selectedList.length) return;
            switch (type) {
                case "allocation":
                    // 分配
                    this.isCheck = false;
                    this.customerAllocationPopupShow = true;
                    break;
                case "transfer":
                    // 转移
                    this.isCheck = false;
                    this.customerTransferPopupShow = true;
                    break;
                case "delete":
                    Dialog.confirm({
                        title: "提示",
                        message: `确定<span class="text_red">删除</span>选中的客户吗？`,
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            const ids = this.selectedList.map((item) => item.id);
                            CustomerPublicDel({ customer_ids: ids }).then((res) => {
                                if (res.code === 200) {
                                    this.isCheck = false;
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.onPullRefreshList();
                                        },
                                    });
                                } else {
                                    this.$toast({
                                        message: res.message,
                                        type: "fail",
                                    });
                                }
                            });
                        })
                        .catch(() => {
                            // on cancel
                        });
                    break;
                case "apply":
                    // 申领
                    checkClaimNum({sea_id: this.searchForm.sea_id, customer_ids: this.selectedList.map(item=> item.id)}).then(res=> {
                        if(res.code === 200) {
                            this.isCheck = false;
                            this.customerApplyPopupShow = true;
                        }
                    })
                    break;
            }
        },
        // 跳转详情页面
        handleClickToDetail({ id, name }) {
            this.$router.push({
                name: "CustomerHighSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: id,
                    name: name.value,
                    sea_id: this.searchForm.sea_id,
                },
            });
        },
        // 公海切换取消
        onCancelHighSeasSelect() {
            this.highSeasSelectVisible = false;
        },
        // 公海切换确认
        handleHighSeasSelect(item) {
            this.searchForm.sea_id = item.value;
            this.highSeasSelectVisible = false;
            this.onPullRefreshList();
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.isCheck = false;
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.onPullRefreshList();
        },
        // 获取公海列表
        getHighSeasManagementList() {
            GetHighSeasManagementList().then((res) => {
                if (res.code === 200) {
                    this.highSeasList = res.data || [];
                    this.highSeasActions = this.highSeasList.map((item) => ({ name: item.seas_name, value: item.id }));
                    if (!this.searchForm.sea_id && this.highSeasList.length) {
                        this.searchForm.sea_id = this.highSeasList[0].id || "";
                    }
                    this.$nextTick(() => {
                        this.onPullRefreshList()
                    });
                }
            });
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                if (!this.searchForm.sea_id) {
                    this.getHighSeasManagementList();
                } else {
                    this.getTableData();
                }
            }
        },
        getTableData() {
            this.loading = true;
            const params = {
                sea_id: this.searchForm.sea_id,
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            GetCustomerPublicList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = this.tableData.concat(data);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                } else {
                    this.loading = false;
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
    },
    beforeDestroy() {
        EventBus.$off('customerAddUpdated', !this.searchForm.sea_id ? this.getHighSeasManagementList: this.onPullRefreshList);
        EventBus.$off('customerEditUpdated', !this.searchForm.sea_id ? this.getHighSeasManagementList: this.onPullRefreshList);
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/customers.scss";

.customer_high_seas_wrap {
    .mobile_container {
        overflow-y: auto;
        overflow-x: hidden;
        padding: 10px 16px;
    }
}
</style>
<style lang="scss">
.van-popover {
    .van-popover__arrow {
        display: none;
    }
}
.top_operator_list {
    width: 104px;
    padding: 4px 0;
    li {
        list-style: none;
        width: 100%;
        height: 38px;
        line-height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }
        &:active {
            background-color: rgba(153, 153, 153, 0.04);
        }
    }
}
</style>
